import React, { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useParams, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const TokenSignInPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { signIn, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && navigate) {
      navigate("/dash");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (token && !isAuthenticated) {
      try {
        signIn(token);
      } catch (e) {
        console.error(e);
        navigate("/auth/sign-in");
      }
    }
  }, [token, navigate, signIn, isAuthenticated]);

  return (
    <React.Fragment>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Nalagam...</span>
      </Spinner>

      <h6 className="mt-4 text-center">Prijava v aplikacijo...</h6>
    </React.Fragment>
  );
};

export default TokenSignInPage;
